export default __webpack_public_path__ + "static/media/tulka_logo.407e322a.svg";